var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
import { margin } from '../../utils/margin';
import { Box } from '../Box/Box';
import { typographyVariantStyles } from '../Typography/StyledTypography';
import { Typography } from '../Typography/Typography';
export const sizeMapping = {
    56: {
        top: '8px',
        padding: '8px 16px',
        spaceAffix: 16,
        borderRadius: 12,
    },
    48: {
        top: '4px',
        padding: '8px 8px',
        spaceAffix: 8,
        borderRadius: 12,
    },
    40: {
        top: '0px',
        padding: '8px 8px',
        spaceAffix: 8,
        borderRadius: 12,
    },
    32: {
        top: '0px',
        padding: '4px 4px',
        spaceAffix: 4,
        borderRadius: 8,
    },
    24: {
        top: '0px',
        padding: '0px 4px',
        spaceAffix: 4,
        borderRadius: 4,
    },
};
export const StyledTextField = styled.div `
  ${margin}
`;
export const StyledInputWrapper = styled.div `
  display: flex;

  min-height: ${({ size }) => `${size}px`};
  margin: 2px;

  ${({ isButton }) => isButton &&
    `
      cursor: pointer;
    `}

  ${({ withStroke, theme }) => withStroke &&
    `
    box-shadow: 0 0 0 1px ${theme.colors.border.default};
    -webkit-box-shadow: 0 0 0 1px ${theme.colors.border.default};
    -webkit-appearance: none;
  `}
  border-radius: ${({ size }) => `${sizeMapping[size].borderRadius}px`};

  color: ${({ theme }) => theme.colors.content.default};
  background-color: ${({ theme }) => theme.colors.background.overlay};

  ${({ withStroke, isFocused, theme }) => withStroke &&
    isFocused &&
    `
    box-shadow: 0 0 0 1.5px ${theme.colors.border.selected};
  `}

  ${({ withStroke, error, theme }) => withStroke &&
    error &&
    `
    box-shadow: 0 0 0 1.5px ${theme.colors.border.critical};
  `}

  ${({ disabled, theme }) => disabled &&
    `
      background: ${theme.colors.background.contrast};
      color: ${theme.colors.content.disabled};
      -webkit-text-fill-color: ${theme.colors.content.disabled};
      /* :hover {
        border-color: ${theme.colors.border.contrast};
      } */
    `}
`;
export const StyledAffix = styled(Box) `
  display: flex;
  justify-content: center;
  align-items: center;
`;
export const StyledCenter = styled(Box) `
  padding: ${({ size }) => sizeMapping[size].padding};
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
`;
export const StyledInput = styled.input `
  width: 100%;
  height: 20px;
  outline: 0;
  border: 0;
  padding: 0;
  margin: 0;
  background: transparent;
  color: ${({ theme }) => theme.colors.content.default};

  ${({ isButton }) => isButton &&
    `
      cursor: pointer;
    `}

  ${typographyVariantStyles.body}

  ${({ displayPlaceholder, theme }) => {
    const placeHolderColor = displayPlaceholder
        ? theme.colors.content.placeholder
        : 'transparent';
    return `
      ::-webkit-input-placeholder {
        /* WebKit browsers */
        color: ${placeHolderColor};
      }
      :-moz-placeholder {
        /* Mozilla Firefox 4 to 18 */
        color: ${placeHolderColor};
      }
      ::-moz-placeholder {
        /* Mozilla Firefox 19+ */
        color: ${placeHolderColor};
      }
      :-ms-input-placeholder {
        /* Internet Explorer 10+ */
        color: ${placeHolderColor};
      }
    `;
}}

  ${({ disabled, theme }) => disabled &&
    `
    color: ${theme.colors.content.disabled};
  `}
`;
export const StyledLabel = styled((_a) => {
    var { isShrink, isHidden, size, isButton, children } = _a, props = __rest(_a, ["isShrink", "isHidden", "size", "isButton", "children"]);
    return (_jsx(Typography, Object.assign({}, props, { children: children })));
}) `
  width: calc(100% - 32px);
  position: absolute;
  left: 0px;
  transition: all 300ms;
  transition-timing-function: linear;

  ${({ isButton }) => isButton &&
    `
    &:hover {
      cursor: pointer;
    }`}

  ${({ size }) => `
    top: ${sizeMapping[size].top};
    padding: ${sizeMapping[size].padding};
  `};

  ${typographyVariantStyles.body}

  ${({ isShrink }) => isShrink &&
    `
    top: 0px;
    ${typographyVariantStyles.footnote}
  `};
  ${({ isHidden }) => isHidden &&
    `
    display: none;
  `};
`;
